import { useState, useEffect } from 'react'
import styles from './CustomCard.module.scss'

// Custom advertisement card
export default function CustomCard({
  header,
  subheader = null,
  ctaText,
  link,
  image,
  adId,
}) {
  const [headerIsOneliner, setHeaderIsOneliner] = useState(false)
  const [subheaderIsOneliner, setSubheaderIsOneliner] = useState(false)
  const [bothHeadersOneliner, setBothHeadersOneliner] = useState(false)
  const [oneTwo, setOneTwo] = useState(false)
  const [twoOne, setTwoOne] = useState(false)
  const [bothTwo, setBothTwo] = useState(false)

  const headerLenghtHandler = () => {
    return header.length <= 15
      ? setHeaderIsOneliner(true)
      : setHeaderIsOneliner(false)
  }

  const subheaderLenghtHandler = () => {
    return subheader.length <= 35
      ? setSubheaderIsOneliner(true)
      : setSubheaderIsOneliner(false)
  }

  const stateHandler = () => {
    if (subheaderIsOneliner && headerIsOneliner) {
      setBothHeadersOneliner(true)
      setTwoOne(false)
      setBothTwo(false)
      setOneTwo(false)
    } else if (subheaderIsOneliner && !headerIsOneliner) {
      setTwoOne(true)
      setBothTwo(false)
      setOneTwo(false)
      setBothHeadersOneliner(false)
    } else if (!subheaderIsOneliner && headerIsOneliner) {
      setBothHeadersOneliner(false)
      setTwoOne(false)
      setBothTwo(false)
      setOneTwo(true)
    } else {
      setBothHeadersOneliner(false)
      setTwoOne(false)
      setBothTwo(true)
      setOneTwo(false)
    }
  }

  useEffect(() => {
    headerLenghtHandler(header)
    subheaderLenghtHandler(subheader)
  }, [])

  useEffect(() => {
    stateHandler()
  }, [headerIsOneliner, subheaderIsOneliner])

  return (
    <article className={styles.teaser} id={`ad-${adId}`}>
      <a href={link} target="_blank" className={styles.link} rel="noreferrer">
        <div
          className={styles.wrap}
          style={{
            backgroundImage: `url(${image})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
          }}
        >
          <div className={styles.filter}>
            <div className={styles.contentWrap}>
              <h1 className={styles.title}>{header}</h1>
              <p className={styles.subheader}>{subheader}</p>
              {bothHeadersOneliner && (
                <button
                  className={`btn btn--primary w-100 ${styles.buttonOneOne}`}
                >
                  {ctaText}
                </button>
              )}
              {oneTwo && (
                <button
                  className={`btn btn--primary w-100 ${styles.buttonOneTwo}`}
                >
                  {ctaText}
                </button>
              )}
              {twoOne && (
                <button
                  className={`btn btn--primary w-100 ${styles.buttonTwoOne}`}
                >
                  {ctaText}
                </button>
              )}
              {bothTwo && (
                <button
                  className={`btn btn--primary w-100 ${styles.buttonBothTwo}`}
                >
                  {ctaText}
                </button>
              )}
            </div>
          </div>
        </div>
      </a>
    </article>
  )
}
